import React from 'react';
import { PropTypes } from 'prop-types';
import { QUESTIONAIRE_RESULTS_ENUM } from '../../utils/inyoUtils';
import ContactManagementAgency from './ContactManagementAgency';
import ContactCommercialAgency from './ContactCommercialAgency';
import InyoNFOverNightPermit from './InyoNFOverNightPermit';
import InyoNFOverNightExitingWhitneyPermit from './InyoNFOverNightExitingWhitneyPermit';
import MtWhitneyDayUsePermit from './MtWhitneyDayUsePermit';
import MtWhitneyOvernightPermit from './MtWhitneyOvernightPermit';
import NoNeedToPermit from './NoNeedToPermit';

const propTypes = {
  result: PropTypes.string,
  permit: PropTypes.object.isRequired,
  pActions: PropTypes.object.isRequired,
  lotteries: PropTypes.array
};

const defaultProps = {};

const resultComponentMap = {
  [QUESTIONAIRE_RESULTS_ENUM.CONTACT_AGENCY]: ContactManagementAgency,
  [QUESTIONAIRE_RESULTS_ENUM.CONTACT_COMMERCIAL_OPERATORS]: ContactCommercialAgency,
  [QUESTIONAIRE_RESULTS_ENUM.INYO_OVERNIGHT_PERMIT]: InyoNFOverNightPermit,
  [QUESTIONAIRE_RESULTS_ENUM.INYO_OVERNIGHT_PERMIT_2]: InyoNFOverNightPermit,
  [QUESTIONAIRE_RESULTS_ENUM.INYO_OVERNIGHT_EXITING_MT_WHITNEY]: InyoNFOverNightExitingWhitneyPermit,
  [QUESTIONAIRE_RESULTS_ENUM.MT_WHITNEY_DAY_USE_PERMIT]: MtWhitneyDayUsePermit,
  [QUESTIONAIRE_RESULTS_ENUM.No_NEED_FOR_PERMIT]: NoNeedToPermit,
  [QUESTIONAIRE_RESULTS_ENUM.MT_WHITNEY_TRAIL_OVERNIGHT_PERMIT]: MtWhitneyOvernightPermit
}

export default class QuestionnaireResult extends React.Component {
  renderResult() {
    const ResultComponent = resultComponentMap[this.props.result];
    return <ResultComponent permit={this.props.permit} result={this.props.result} pActions={this.props.pActions} lotteries={this.props.lotteries} />;
  }

  render() {
    return (
      <div className="rec-questionnaire-result">
        <div className="rec-questionnaire-finished">Finished</div>
        {this.renderResult()}
      </div>
    );
  }
}

QuestionnaireResult.displayName = 'QuestionnaireResult';
QuestionnaireResult.propTypes = propTypes;
QuestionnaireResult.defaultProps = defaultProps;
